// Liste des partenaires pilotés par la nouvelle route /partners/all
// On exclut les partenaires masqués (visibility = 0).
export const getPartnersApiSelector = state =>
	(state.partnersApi || []).filter(
		// eslint-disable-next-line eqeqeq
		partner => partner && partner.visibility != 0
	);

export const getOnboardingStepSelector = (state, prefix) => {
	const partner = (state.partnersApi || []).find(
		p => p && p.prefix === prefix
	);
	return (partner && partner.onboarding && partner.onboarding.step) || null;
};
